import { ConversationAttachmentsContract } from '@terra/shared-contracts-conversation-attachments';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'chat';

export const conversationAttachmentsClient = createTerraOrpcClient({
  contract: ConversationAttachmentsContract,
  serviceName: SERVICE_NAME,
});
